<template>
  <el-button
    class="elsa-button"
    plain
    round
    v-bind="$attrs"
  >
    <img v-if="customIcon !== '' && iconLeft" :src="getIconUrl" v-bind:class="{ iconLeft: iconLeft }"/>
    <slot/>
    <img v-if="customIcon !== '' && !iconLeft" :src="getIconUrl" />
  </el-button>
</template>

<script>
export default {
  name: "Button",
  props: {
    customIcon: {
      type: String,
      default: ''
    },
    iconLeft: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getIconUrl() {
      return require(`@/assets/images/${this.customIcon}.svg`)
    }
  },
}
</script>

<style lang="scss" scoped>
  .elsa-button {
    transition: background-color 0.2s, font-weight 0.2s;
    min-height: 40px;
    min-width: 144px;
    text-transform: capitalize;
    font-family: 'SF Pro Display';
    border: none;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    border-radius: 8px;

    &:not([disabled]):hover {
      font-weight: 800;
    }

    span img {
      vertical-align: bottom;
      width: 16px;
      height: 16px;
      padding-left: 10px;
      padding-right: 0px;
      &.iconLeft{
        padding-left:0px;
        padding-right:10px;
      }
    }
  }
</style>
